import { render, staticRenderFns } from "./edit-info.vue?vue&type=template&id=5fbf92b3&scoped=true"
import script from "./edit-info.vue?vue&type=script&lang=js"
export * from "./edit-info.vue?vue&type=script&lang=js"
import style0 from "./edit-info.vue?vue&type=style&index=0&id=5fbf92b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbf92b3",
  null
  
)

export default component.exports